export default {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  UNUSED: 'UNUSED',
  OTHER: 'OTHER'
}
